// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"6a12c779","549":"26e317e3","746":"396d208f","941":"5e6f2f1c"}[chunkId] + ".chunk.css";
};